module.exports = __webpack_public_path__ + "static/img/qiye.e4f9d99.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/qiye.png
// module id = ip+V
// module chunks = 52